import type { FC } from 'react';
import React from 'react';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Link } from '@alfa-bank/site-link';
import { Grid } from '@alfa-bank/site-grid-universal';
import { AnalyticsEventSender } from '@alfa-bank/site-analytics-event-sender/analytics-event-sender';

import type { TErrorAuthorizationToCourierCallDesktop } from '../model';
import { ErrorIcon } from '../../../components/error-icon';
import { OFFICES_LINK } from '../../../config';
import { defaultErrorAuthorizationToCourierCallSettings } from '../config/default-values';
import { analyticsErrorAuthorizationToCourierCallStepSmev } from '../analytics';

export const ErrorAuthorizationToCourierCallDesktop: FC<
    TErrorAuthorizationToCourierCallDesktop
> = ({
    Aligner,
    Text,
    buttonText = defaultErrorAuthorizationToCourierCallSettings.buttonText,
    description = defaultErrorAuthorizationToCourierCallSettings.description,
    title = defaultErrorAuthorizationToCourierCallSettings.title,
}) => {
    return (
        <Aligner>
            <ErrorIcon />
            <Text styler={{ marginBottom: 16, marginTop: 24 }} tag="h2" view="medium">
                {title}
            </Text>
            <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-medium">
                {description}
            </Text>
            <Grid collapse columnsWidth={[254]} styler={{ marginTop: 32 }}>
                <AnalyticsEventSender
                    $events={{
                        onClick: {
                            data: analyticsErrorAuthorizationToCourierCallStepSmev.buttonClick,
                        },
                    }}
                >
                    <Link border="hidden" href={OFFICES_LINK} target="_blank">
                        <Button block size="s" view="tertiary">
                            {buttonText}
                        </Button>
                    </Link>
                </AnalyticsEventSender>
            </Grid>
        </Aligner>
    );
};
